import ActionTypes from '../constants/actionTypes'

const initialState = {
  loading: false,
  stores: [],
}

export default function stores(state = initialState, action) {
  let { payload } = action
  switch (action.type) {
    case ActionTypes.GET_STORE.REQUEST:
      return {
        ...state,
        loading: true,
      }
    case ActionTypes.GET_STORE.SUCCESS:
      return {
        ...state,
        stores: [...payload.data],
        loading: false,
      }
    case ActionTypes.GET_STORE.FAILURE:
      return {
        ...state,
        loading: false,
      }
    case ActionTypes.FORMAT_STORE.REQUEST:
      return {
        ...initialState,
      }
    default:
      return state
  }
}
